// extracted by mini-css-extract-plugin
module.exports = {"root":"TimifyLoader_root__2qQOm","fullHeight":"TimifyLoader_fullHeight__3RLZZ","overlay":"TimifyLoader_overlay__2GuJe"};